import { render, staticRenderFns } from "./add-creative.vue?vue&type=template&id=280131a2&scoped=true"
import script from "./add-creative.vue?vue&type=script&lang=js"
export * from "./add-creative.vue?vue&type=script&lang=js"
import style0 from "./add-creative.vue?vue&type=style&index=0&id=280131a2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280131a2",
  null
  
)

export default component.exports